/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_IFREIGHTERMINAL_SCHEMA = Yup.object().shape({
    //general section Rules:
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),


    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
            if (value === null) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

            for (const email of emails) {
                if (!emailRegex.test(email.trim())) {
                    throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    nodeNameval: Yup.string("End Node Name is alphanumeric").nullable(true),
    dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true),
    dateValidFor: Yup.string("Valid for is a Year"),
    remarks: Yup.string("remarks").nullable(true),

    freightImpPmDescDTO: Yup.object().shape({
        projectName: Yup.string('Value should be a text').nullable(true),
        typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
        length: Yup.number('Value should be number').nullable(true),
        totalCostCapex: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        estiImpDeadline: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    freightImpPmEligiTentDTO: Yup.object().shape({
        interModality: Yup.boolean().nullable(true),
        trainLength740M: Yup.boolean().nullable(true),
        electrifideAccess: Yup.boolean().nullable(true),
        openAvailability: Yup.boolean().nullable(true),
        connectionTwoModesTransport: Yup.boolean().nullable(true),
        rechargingStation: Yup.boolean().nullable(true),
        hydrogenRefuellingStation: Yup.boolean().nullable(true),
        marketProspectiveAnalysis: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    freightImpPmIndicatorsDTO: Yup.object().shape({
        siAnnTraffDemGro: Yup.number('Value should be number').nullable(true),
        siModalTrans: Yup.number('Value should be number').nullable(true),
        siAnnTraffAcciRateRed: Yup.number('Value should be number').nullable(true),
        eiEirr: Yup.number('Value should be number').nullable(true),
        eiNpv: Yup.number('Value should be number').nullable(true),
        eiSdr: Yup.number('Value should be number').nullable(true),
        eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
        eiProjConstCost: Yup.number('Value should be number').nullable(true),
        eiTotalProjCost: Yup.number('Value should be number').nullable(true),
        fiFirr: Yup.number('Value should be number').nullable(true),
        fiFnpv: Yup.number('Value should be number').nullable(true),
        fiFdr: Yup.number('Value should be number').nullable(true),
        fiWacc: Yup.number('Value should be number').nullable(true),
        fiFirtsYearProf: Yup.date("Valid from is a Date").nullable(true),
        fiDscr: Yup.number('Value should be number').nullable(true),
        eniCo2Ems: Yup.number('Value should be number').nullable(true),
        eniNoxEms: Yup.number('Value should be number').nullable(true),
        eniSo2Ems: Yup.number('Value should be number').nullable(true),
        eniNmhcEms: Yup.number('Value should be number').nullable(true),
        eniPpm: Yup.number('Value should be number').nullable(true),
        eniNoiseLevel: Yup.number('Value should be number').nullable(true),
        eniCliChangeRes: Yup.number('Value should be number').nullable(true),
        eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    freightImpPmPiDTO: Yup.object().shape({
        forecastConstPeriod: Yup.number('Value should be number').nullable(true),
        actualConstPeriod: Yup.number('Value should be number').nullable(true),
        forecastCapex: Yup.number('Value should be number').nullable(true),
        actualCapex: Yup.number('Value should be number').nullable(true),
        forecastOpex: Yup.number('Value should be number').nullable(true),
        actualOpex: Yup.number('Value should be number').nullable(true),
        forecastMaintCost: Yup.number('Value should be number').nullable(true),
        actualMaintCost: Yup.number('Value should be number').nullable(true),
        interestDuringConst: Yup.number('Value should be number').nullable(true),
        ebitda: Yup.number('Value should be number').nullable(true),
        forecastRevenue: Yup.number('Value should be number').nullable(true),
        actualRevenue: Yup.number('Value should be number').nullable(true),
        actualTerminalTraffic: Yup.number('Value should be number').nullable(true),
        actualTrainTraffic: Yup.number('Value should be number').nullable(true),
        forecastPassTraffic: Yup.number('Value should be number').nullable(true),
        actualPassTraffic: Yup.number('Value should be number').nullable(true),
        forecastFreightTn: Yup.number('Value should be number').nullable(true),
        actualFreightTn: Yup.number('Value should be number').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    freightImpPmStatusDTO: Yup.object().shape({
        implemented: Yup.string('Value should be a text').nullable(true),
        ongoingProjFs: Yup.string('Value should be a text').nullable(true),
        matureProjFs: Yup.string('Value should be a text').nullable(true),
        projUnderPrep: Yup.string('Value should be a text').nullable(true),
        projStatusDesc: Yup.number('Value should be number').nullable(true),
        initProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        actualProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        projFundNatBudg: Yup.number('Value should be number').nullable(true),
        projFundWb: Yup.number('Value should be number').nullable(true),
        projFundEbrd: Yup.number('Value should be number').nullable(true),
        projFundEib: Yup.number('Value should be number').nullable(true),
        otherIfi: Yup.number('Value should be number').nullable(true),
        otherIfiSpec: Yup.string('Value should be a text').nullable(true),
        concessions: Yup.number('Value should be number').nullable(true),
        concessionSpec: Yup.string('Value should be a text').nullable(true),
        euFund: Yup.number('Value should be number').nullable(true),
        euFundSpec: Yup.string('Value should be a text').nullable(true),
        otherFund: Yup.string('Value should be a text').nullable(true),
        otherFundSpec: Yup.string('Value should be a text').nullable(true),
        projDocTitle: Yup.string('Value should be a text').nullable(true),
        projDocPrepBy: Yup.string('Value should be a text').nullable(true),
        projDocSupervBy: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    freightImpPmTentcompDTO: Yup.object().shape({
        befInterModality: Yup.boolean().nullable(true),
        aftInterModality: Yup.boolean().nullable(true),
        befTrainLength740M: Yup.boolean().nullable(true),
        aftTrainLength740M: Yup.boolean().nullable(true),
        befElectrification: Yup.boolean().nullable(true),
        aftElectrification: Yup.boolean().nullable(true),
        befOpenAvail: Yup.boolean().nullable(true),
        aftOpenAvail: Yup.boolean().nullable(true),
        befConnectionTwoModesTransport: Yup.boolean().nullable(true),
        aftConnectionTwoModesTransport: Yup.boolean().nullable(true),
        befRechargingStation: Yup.boolean().nullable(true),
        aftRechargingStation: Yup.boolean().nullable(true),
        befHydrogenRefuellingStation: Yup.boolean().nullable(true),
        aftHydrogenRefuellingStation: Yup.boolean().nullable(true),
        befMarketProspectiveAnalysis: Yup.boolean().nullable(true),
        aftMarketProspectiveAnalysis: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
});

const IFREIGHTERMINAL_INIT = {
    //general section Rules:
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    tenTCategory: "",
    nodeNameval: "",
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    remarks: "",
    freightImpPmDescDTO: {
        projectName: "",
        typeForeseenInterven: "",
        length: 0,
        totalCostCapex: 0,
        estiImpDeadline: "",
        remarks: "",
    },
    freightImpPmEligiTentDTO: {
        interModality: false,
        trainLength740M: false,
        electrifideAccess: false,
        openAvailability: false,
        connectionTwoModesTransport: false,
        rechargingStation: false,
        hydrogenRefuellingStation: false,
        marketProspectiveAnalysis: false,
        remarks: "",
    },
    freightImpPmIndicatorsDTO: {
        siAnnTraffDemGro: 0,
        siModalTrans: 0,
        siAnnTraffAcciRateRed: 0,
        eiEirr: 0,
        eiNpv: 0,
        eiSdr: 0,
        eiProjPlanDesCost: 0,
        eiProjConstCost: 0,
        eiTotalProjCost: 0,
        fiFirr: 0,
        fiFnpv: 0,
        fiFdr: 0,
        fiWacc: 0,
        fiFirtsYearProf: "",
        fiDscr: 0,
        eniCo2Ems: 0,
        eniNoxEms: 0,
        eniSo2Ems: 0,
        eniNmhcEms: 0,
        eniPpm: 0,
        eniNoiseLevel: 0,
        eniCliChangeRes: 0,
        eniProteNatuaAff: 0,
        remarks: ""
    },
    freightImpPmPiDTO: {
        forecastConstPeriod: 0,
        actualConstPeriod: 0,
        forecastCapex: 0,
        actualCapex: 0,
        forecastOpex: 0,
        actualOpex: 0,
        forecastMaintCost: 0,
        actualMaintCost: 0,
        interestDuringConst: 0,
        ebitda: 0,
        forecastRevenue: 0,
        actualRevenue: 0,
        forecastTerminalTraffic: 0,
        actualTerminalTraffic: 0,
        forecastPassTraffic: 0,
        actualPassTraffic: 0,
        forecastFreightTn: 0,
        actualFreightTn: 0,
        remarks: ""
    },
    freightImpPmStatusDTO: {
        implemented: "",
        ongoingProjFs: "",
        matureProjFs: "",
        projUnderPrep: "",
        projStatusDesc: 0,
        initProjCompDate: "",
        actualProjCompDate: "",
        projFundNatBudg: 0,
        projFundWb: 0,
        projFundEbrd: 0,
        projFundEib: 0,
        otherIfi: 0,
        otherIfiSpec: "",
        concessions: 0,
        concessionSpec: "",
        euFund: 0,
        euFundSpec: "",
        otherFund: "",
        otherFundSpec: "",
        projDocTitle: "",
        projDocPrepBy: "",
        projDocSupervBy: "",
        remarks: ""
    },
    freightImpPmTentcompDTO: {
        befInterModality: false,
        aftInterModality: false,
        befTrainLength740M: false,
        aftTrainLength740M: false,
        befElectrification: false,
        aftElectrification: false,
        befOpenAvail: false,
        aftOpenAvail: false,
        befConnectionTwoModesTransport: false,
        aftConnectionTwoModesTransport: false,
        befRechargingStation: false,
        aftRechargingStation: false,
        befHydrogenRefuellingStation: false,
        aftHydrogenRefuellingStation: false,
        befMarketProspectiveAnalysis: false,
        aftMarketProspectiveAnalysis: false,
        remarks: ""
    },
}

export { TODIS_IFREIGHTERMINAL_SCHEMA, IFREIGHTERMINAL_INIT };